/**
 * apiBase.js
 * Path: frontend/src/api/apiBase.js
 * Description: Wspólna konfiguracja axios dla API Teflis.
 * Related: api/*.js
 */

import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || "/api",
});

export const SESSION_INVALIDATED_EVENT = "teflis:session-invalidated";

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(new Event(SESSION_INVALIDATED_EVENT));
    }
    return Promise.reject(error);
  }
);

function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export { api, authHeaders };
